import { LoyaltyParamsService } from './../../../services/loyalty/params.service';
import { CustomerSet } from './../../../models/customer-set-model';
import { CalendarTranslateService } from './../../../modules/UIKit/services/calendarTranslate.service';
import { Calendar } from 'primeng/primeng';
import { ConfirmationService } from 'primeng/components/common/api';
import { TranslateService } from '@ngx-translate/core';
import { QueryBuilderConfig } from 'angular2-query-builder';
import { CustomerSetBuilderService } from './../../../services/customer/customer-set-builder.service';
import { ExtSearchService } from './../../../services/ext-search/ext-search.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as moment from 'moment';
import * as FileSaver from 'file-saver';
import { exit } from 'process';
import { CustomerSetExecutionListComponent } from '../customer-set-execution-list/customer-set-execution-list.component';

@Component({
  selector: 'app-customer-set-builder',
  templateUrl: './customer-set-builder.component.html',
  styleUrls: ['./customer-set-builder.component.css']
})
export class CustomerSetBuilderComponent implements OnInit {
  extSearchQuery: any;
  extSearchConfig: QueryBuilderConfig;
  setCode: string;
  setDescription: string;
  setVersion: number;
  setId: {id: number, id_plan: number};
  setResults: number;
  dialogTitle: string;
  showDialog = false;
  showSetSave = false;
  showSetLoad = false;
  showSetResults = false;
  showSetExecutions = false;
  clusterSaveThreshold: number;
  executionType = 'single';
  singleExecDate: Date;
  recExecStartDate: Date;
  recExecEndDate: Date;
  cronJobsFrequency: string = '';
  enabled: boolean;
  enabledDeleteCustomer: boolean;
  clusterHeadId: number;
  modifyQuery: boolean;
  planningDate: boolean;
  planningTitle: string;
  saveQuery: boolean;
  query: any;
  warningTitle: string;
  message: string;
  showAlreadyExist: boolean;
  showCreateCluster: boolean;

  @ViewChild('queryBuilder') queryBuilder;
  @ViewChild('queryBuilder', {read: ElementRef}) queryBuilderRef: ElementRef;

  @ViewChild(CustomerSetExecutionListComponent) customerSetExecutionList: CustomerSetExecutionListComponent;

  constructor(
    private extSearchService: ExtSearchService,
    private customerSetBuilderService: CustomerSetBuilderService,
    private translateService: TranslateService,
    private confirmationService: ConfirmationService,
    private calendarTranslateService: CalendarTranslateService,
    private paramsService: LoyaltyParamsService
  ) { }

  ngOnInit() {
    this.extSearchService.getExtSearchConfig('extsearch-cust-query').subscribe(res => {
      this.query = res;
      this.setExtSearch(this.query);
    });
    this.paramsService.getParamByKey('CLUSTER.QUERY.MAX').subscribe(res => this.clusterSaveThreshold = +res.param_code);
  }

  openSetLoad() {
    this.showDialog = this.showSetLoad = true;
    this.dialogTitle = this.translateService.instant('customerSetBuilder.loadSet');
  }

  openSetSave() {
    this.showDialog = this.showSetSave = true;
    this.dialogTitle = this.translateService.instant('customerSetBuilder.saveSet');
    this.planningTitle = this.translateService.instant('customerSetBuilder.planningTitle');
    this.saveQuery = true;
  }

  updateSet() {
    this.planningDate = false;
    this.saveQuery = false;
    this.showDialog = this.showSetSave = true;
    this.dialogTitle = this.translateService.instant('customerSetBuilder.saveSet');
  }

  updatePlanningDate() {
    this.planningDate = true
    this.showDialog = this.showSetSave = true;
    this.dialogTitle = this.translateService.instant('customerSetBuilder.saveSet');
  }

  loadSet(setId: {id: number, id_plan: number}) {
    this.modifyQuery = true;
    this.setId = setId;
    this.customerSetBuilderService.getQuery(setId.id).subscribe(res => {
      this.setCode = res[0]['code'];
      this.setDescription = res[0]['description'];
      this.setVersion = res[0]['version'];
      this.extSearchQuery = res[0]['query_condition'];
      this.enabled = res[0].flg_active === '0' ? true : false;
      this.enabledDeleteCustomer = res[0].flg_delete_customer === '0' ? true : false;
      this.clusterHeadId = res[0]['cluster_head_id'];
      if (res[0].cron_string) {
        this.cronJobsFrequency = res[0]['cron_string'];
        this.recExecStartDate = new Date(res[0].planned_start_date);
        this.recExecEndDate = new Date(res[0].planned_end_date);
        this.executionType = 'recurring';
      } else {
        this.singleExecDate = new Date(res[0].planned_start_date);
        this.executionType = 'single';
      }
      this.closeDialog();
    });
  }

  goBack() {
    this.setExtSearch(this.query);
    this.modifyQuery = false;
    this.setCode = null;
    this.setDescription = null;
    this.executionType = 'single';
    this.singleExecDate = null;
    this.recExecStartDate = null;
    this.recExecEndDate = null;
    this.cronJobsFrequency = null;
    this.clusterHeadId = null;
    this.saveQuery = false;
    this.planningDate = false;
    this.showSetExecutions = false;
    this.setId = null;
  }

  setExtSearch(setting){
    this.extSearchQuery = setting[0].configValue.query;
      const configFields = setting[0].configValue.QueryBuilderConfig.fields;
      const configFieldsArr = [];
      for (const prop in configFields) {
        //#endregion
        if (configFields[prop].hasOwnProperty('id')) {
          configFieldsArr.push({[`${prop}`]: configFields[prop]});
        } else {
          this.extSearchConfig = setting[0].configValue.QueryBuilderConfig;
          break;
        }
      }
      if (configFieldsArr.length > 0) {
        configFieldsArr.sort((a, b) => {
          const idA = a[Object.keys(a)[0]]['id'];
          const idB = b[Object.keys(b)[0]]['id'];
          let comparison = 0;
            if (idA > idB) {
              comparison = 1;
            } else if (idA < idB) {
              comparison = -1;
            }
            return comparison;
        });
        const configFieldsObject = {fields: {}};
        configFieldsArr.forEach(field => Object.assign(configFieldsObject.fields, field));
        this.extSearchConfig = configFieldsObject;
      };
  }

  closeDialog() {
    this.showDialog =
    this.showSetLoad =
    this.showSetSave =
    this.showSetExecutions =
    this.showSetResults = false;
    this.showAlreadyExist = false;
  }

  checkResults(checkForSave = false, newSetData?: CustomerSet) {
    if(this.checkExtSearchPopulated()){
    this.customerSetBuilderService.checkQueryResults(this.extSearchQuery).subscribe(res => {
      if (checkForSave) {
        // Setto la quantità di risultati (query_count) nel payload di salvataggio
        newSetData.query_count = res;
        // Operazione di controllo quantità risultati prima del salvataggio
        if (res > this.clusterSaveThreshold) {
          // Richiesta di conferma con alert per quantità risultati supera soglia di allerta
          this.confirmationService.confirm({
            header: this.translateService.instant('customerSetBuilder.warning'),
            message: this.translateService.instant('customerSetBuilder.alertSaveMsg',{results: this.clusterSaveThreshold}),
            accept: () => this.saveSet(newSetData),
            acceptLabel: 'Ok'
          });
        } else {
          // Semplice richiesta di conferma
          this.confirmationService.confirm({
            header: this.translateService.instant('customerSetBuilder.confirmSaveHeader'),
            message: this.translateService.instant('customerSetBuilder.confirmSaveMsg', {results: res}),
            accept: () => this.saveSet(newSetData),
            acceptLabel: 'Ok'
          });
        }
      } else {
        // Operazione di controllo quantità risultati da visualizzare nella relativa modale
        this.setResults = res;
        this.dialogTitle = this.translateService.instant('customerSetBuilder.queryResult');
        this.showSetResults = this.showDialog = true;
      }
    });
    }else{
      this.confirmationService.confirm({
        header: this.translateService.instant('customerSetBuilder.warning'),
        message: this.translateService.instant('customerSetBuilder.warningEmptyFields',{results: this.clusterSaveThreshold}),
        acceptLabel: 'Ok',
        rejectVisible: false
      });
    }
  }

  private checkExtSearchPopulated(): boolean {
    if (!this.extSearchQuery || !this.extSearchQuery.rules || this.extSearchQuery.rules.length === 0) {
      return false; // Se non ci sono regole, ritorna false
    }

    return this.extSearchQuery.rules.every(rule => {
      // Controlla se l'operatore è "exist" o "not exists"
      if (rule.operator === 'exists' || rule.operator === 'not exists') {
        return true; // Salta il controllo su value
      }

      if (Array.isArray(rule.value)) {
        return rule.value.length > 0 && rule.value.every(val => val !== undefined && val !== null && val !== '');
  }

      return rule.value !== undefined && rule.value !== null && rule.value !== ''; // Controlla se value è valorizzato
    });
  }
  /**
   * Mostra in modale la lista delle esecuzioni della query selezionata
   */
  checkSetExecutions() {
    this.dialogTitle = this.translateService.instant('customerSetBuilder.executionsHistorical');
    this.showSetExecutions = true;
  }

  saveSet(newSetData: CustomerSet) {
    this.customerSetBuilderService.saveQuery(newSetData).subscribe(res => {
      // Se esiste già un set/query con il nome scelto, apro alert per conferma update
      if (res === "KoncentroCustomer.QueryAlreadyExist" && this.modifyQuery) {
        this.confirmationService.confirm({
          header: this.translateService.instant('customerSetBuilder.warning'),
          message: this.translateService.instant('customerSetBuilder.queryAlreadyExistAlertMsg'),
          accept: () => {
            // Prima di Update, aggiunta id ed aggiornamento versione
            Object.assign(newSetData, {id: this.setId.id});
            Object.assign(newSetData, {id_plan: this.setId.id_plan});
            newSetData.version = this.setVersion;
            this.customerSetBuilderService.updateQuery(newSetData).subscribe((set) => {
              this.loadSet({id: set.id, id_plan: set.id_plan});
              this.customerSetExecutionList.table.refresh();
            })
          },
          acceptLabel: 'Ok'
        });
      } else if(res === "KoncentroCustomer.QueryAlreadyExist" && (!this.modifyQuery || this.modifyQuery == null)) {
        this.warningTitle = this.translateService.instant('customerSetBuilder.warning');
        this.message = this.translateService.instant('customerSetBuilder.queryAlreadyExist');
        this.showAlreadyExist = true;
      } else {
        this.setCode = newSetData.code;
        this.setDescription = newSetData.description;
        this.loadSet({id: res.id, id_plan: res.id_plan});
        this.enabled = newSetData.flg_active === '0' ? true : false;
        this.enabledDeleteCustomer = newSetData.flg_delete_customer === '0' ? true : false;
        this.customerSetExecutionList.table.refresh();
      }
    });
  }

  closeAlready() {
    this.showAlreadyExist = false;
  }

  exportResults() {
    this.customerSetBuilderService.exportQueryResults(this.extSearchQuery).subscribe(
      filename => {
        this.customerSetBuilderService.downloadExcel(filename).subscribe(res => {
          FileSaver.saveAs(res, filename);
          this.closeDialog();
        })
      }
    );
  }

  ngAfterContentChecked(): void {
    /*
      Fix per quando viene caricata una query con dei campi data,
      i quali vengono restituiti dalla getQuery in formato stringa,
      causando un errore nel calendar del queryBuilder
      (commentata 08/03/2024 perchè non serve più a seguito di modifiche per KS-5487)
    */
/*
    if (this.queryBuilder && this.queryBuilder.dateFieldRef && this.queryBuilder.dateFieldRef._results && this.queryBuilder.dateFieldRef._results.length > 0) {
      this.queryBuilder.dateFieldRef._results.forEach((calendar: Calendar) => {
        if (calendar.value && typeof calendar.value === 'string') {
          calendar.value = new Date(calendar.value);
          calendar.inputFieldValue = moment(new Date(calendar.value)).format(this.calendarTranslateService.pcalendarTranslate.dateFormatFilter.toUpperCase());
        }
      });
    }
    */


  }

  closeCreateCluster() {
    this.showCreateCluster = false;
  }

  openCreateCluster() {
    this.showCreateCluster = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-set-builder/customer-set-builder.component.ts